<template>
  <div>
    <Title
      :title-text="$t('resetPassword_title')"
      :text="`${$t('requestPassword_title_text')}`"
      data-qa="por-request--title" />
    <RequestPasswordForm data-qa="request-password-form" />
  </div>
</template>

<script>
import { track } from '@/services/tracking'

import RequestPasswordForm from '@/components/forms/request'
import Title from '@/components/title'

export default {
  name: 'RequestPassword',
  components: {
    Title,
    RequestPasswordForm
  },
  mounted () {
    track({ name: 'page view', params: { module: 'reset password' } })
  }
}
</script>
